import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { Models } from '.';
import { IEmployeeBoxProps } from '../components/employee-box/employee-box';
import { ICheckboxProps } from '../components/form/components/checkbox/checkbox';
import { IGroupedCheckboxesProps } from '../components/form/components/groupedCheckboxes/groupedCheckboxes';
import { IInputProps } from '../components/form/components/input/input';
import { IFormComponentProps } from '../components/form/contact-form/contact-form-types';
import { CheckboxModel } from './checkbox-model';
import { CheckboxesGroupModel } from './checkboxes-group.model';
import { InputTextModel } from './input-text-model';

export class FormComponentModel extends ContentItem {
  get contactPerson(): IEmployeeBoxProps | null {
    const getPerson = get(
      this._config,
      'elements.contact_person.value[0].elements.person_data.value[0]',
      null
    );
    const transformPerson = getPerson
      ? Models.EmployeeBoxModel.create(getPerson as IEmployeeBox)
      : null;

    return transformPerson;
  }

  get postUrl(): string {
    return get(this._config, 'elements.post_url.value', '');
  }

  get privacyPolicyAgreement(): string {
    return get(this._config, 'elements.privacy_policy_agreement.value', '');
  }

  get formClassName(): string {
    return get(this._config, 'elements.class_name.value', '');
  }

  get inputs(): IInputProps[] {
    const getInputText = get(
      this._config,
      'elements.form_fields__inputs.value',
      null
    );

    const transformInputText = getInputText
      ? getInputText.map((input: IInputText) => InputTextModel.create(input))
      : null;

    return transformInputText;
  }

  get checkboxes(): ICheckboxProps[] {
    const getCheckbox = get(
      this._config,
      'elements.form_fields__checkboxes.value',
      null
    );

    const transformCheckbox = getCheckbox
      ? getCheckbox.map((checkbox: ICheckbox) => CheckboxModel.create(checkbox))
      : null;

    return transformCheckbox;
  }

  get groupedCheckboxes(): IGroupedCheckboxesProps[] {
    const getGroupedCheckboxes = get(
      this._config,
      'elements.form_fields__grouped_checkboxes.value',
      null
    );

    const transformGroupedCheckboxes = getGroupedCheckboxes
      ? getGroupedCheckboxes.map((checkboxesGroup: IGroupedCheckboxes) => {
          return CheckboxesGroupModel.create(checkboxesGroup);
        })
      : null;

    return transformGroupedCheckboxes;
  }

  get contactButtonCta(): string {
    return get(this._config, 'elements.submit_button_text.value', '');
  }

  get campaignId(): string {
    return get(this._config, 'elements.campaign_id.value', '');
  }

  get webinarTag(): string {
    return get(this._config, 'elements.webinar_tag.value', '');
  }

  get useReCAPTCHA(): boolean {
    return (
      get(this._config, 'elements.use_recaptcha.value[0].codename') === 'true'
    );
  }

  get successMessage(): string {
    return get(this._config, 'elements.success_message.value', '');
  }

  public static create(data: IFormComponent): IFormComponentProps {
    const {
      contactButtonCta,
      inputs,
      checkboxes,
      groupedCheckboxes,
      postUrl,
      privacyPolicyAgreement,
      successMessage,
      contactPerson,
      formClassName,
      campaignId,
      webinarTag,
      useReCAPTCHA
    } = new FormComponentModel(data);

    return {
      contactButtonCta,
      inputs,
      checkboxes,
      groupedCheckboxes,
      postUrl,
      privacyPolicyAgreement,
      successMessage,
      contactPerson,
      formClassName,
      campaignId,
      webinarTag,
      useReCAPTCHA
    };
  }
}
